import { apiHelper } from './api';

export const categoryService = {
  // Get all categories with filters
  getCategories: async ({ skip = 0, limit = 10, module_id, is_active } = {}) => {
    const params = new URLSearchParams();
        
    params.append('skip', skip);
    params.append('limit', limit);
        
    if (module_id) params.append('module_id', module_id);
    if (is_active !== undefined) params.append('is_active', is_active);

    const response = await apiHelper.get(`/categories?${params.toString()}`);
    return response.data;
  },

  // Get categories with subcategories
  getCategoriesWithSubcategories: async (moduleId = null) => {
    const params = moduleId ? `?module_id=${moduleId}` : '';
    const response = await apiHelper.get(`/categories/with-subcategories${params}`);
    return response.data;
  },

  // Get categories by module
  getCategoriesByModule: async (moduleId) => {
    const response = await apiHelper.get(`/categories/module/${moduleId}`);
    return response.data;
  },

  // Get single category
  getCategory: async (categoryId) => {
    const response = await apiHelper.get(`/categories/${categoryId}`);
    return response.data;
  },

  // Get category with subcategories
  getCategoryWithSubcategories: async (categoryId) => {
    const response = await apiHelper.get(`/categories/${categoryId}/with-subcategories`);
    return response.data;
  },

  // Create category (Admin only)
  createCategory: async (categoryData) => {
    const response = await apiHelper.post('/categories', categoryData);
    return response.data;
  },

  // Update category (Admin only)
  updateCategory: async (categoryId, categoryData) => {
    const response = await apiHelper.put(`/categories/${categoryId}`, categoryData);
    return response.data;
  },

  // Delete category (Admin only)
  deleteCategory: async (categoryId) => {
    const response = await apiHelper.delete(`/categories/${categoryId}`);
    return response.data;
  },

  // Deactivate category (Admin only)
  deactivateCategory: async (categoryId) => {
    const response = await apiHelper.post(`/categories/${categoryId}/deactivate`);
    return response.data;
  },

  // Activate category (Admin only)
  activateCategory: async (categoryId) => {
    const response = await apiHelper.post(`/categories/${categoryId}/activate`);
    return response.data;
  }
};